"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateBlog = exports.getBlog = exports.addBlog = exports.getBlogs = void 0;
const _ = require("lodash");
const getBlogs = async (supabase) => {
    const { data: blogs, error } = await supabase.from("blog").select(`*`);
    if (!error)
        return blogs;
    return error;
};
exports.getBlogs = getBlogs;
const addBlog = async (supabase, obj) => {
    const { data, error } = await supabase.from("blog").insert([obj]).select();
    if (!error)
        return data;
    return error;
};
exports.addBlog = addBlog;
const getBlog = async (supabase, id) => {
    const { data: airport, error } = await supabase
        .from("blog")
        .select(`*`)
        .eq("id", id)
        .single();
    if (!error)
        return airport;
    return error;
};
exports.getBlog = getBlog;
const updateBlog = async (supabase, obj) => {
    const updateObj = _.cloneDeep(obj);
    const { data, error } = await supabase
        .from("blog")
        .update(updateObj)
        .eq("id", updateObj.id)
        .select(`*`)
        .single();
    if (!error)
        return data;
    return error;
};
exports.updateBlog = updateBlog;
